import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Link } from 'components';
import * as styles from './styles.module.scss';

const FooterNavigation = () => {
  const {
    prismicSettings: { data: footerNavigationDataRaw },
  } = useStaticQuery(settingsQuery);

  const footerNavData = [1, 2, 3, 4, 5, 6].map((count) => ({
    footerNavLink: footerNavigationDataRaw[`footer_navigation_link_${count}`],
    footerNavLinkUrl: footerNavigationDataRaw[`footer_navigation_link_${count}_url`],
    footerNavLinkSublinks: footerNavigationDataRaw[`footer_navigation_link_${count}_sublinks`],
  }));

  // Group sections into columns. The short sections (Resources / Work With Us / Employers)
  // stack together in one column so every section is only as tall as its own content
  // instead of being stretched by a shared grid row.
  const columns = [
    { key: 'column-1', sections: [footerNavData[0]] },
    { key: 'column-2', sections: [footerNavData[1], footerNavData[2], footerNavData[3]] },
    { key: 'column-3', sections: [footerNavData[4]] },
    { key: 'column-4', sections: [footerNavData[5]] },
  ];

  return (
    <nav className={styles.footerLinksContainer}>
      {columns.map((column) => (
        <div key={column.key} className={styles.footerColumn}>
          {column.sections.map((navColData) => {
            const title = navColData?.footerNavLink?.text;
            const link = navColData?.footerNavLinkUrl?.url;
            const sublinks = navColData?.footerNavLinkSublinks;

            return <FooterNavigationCol key={title} title={title} link={link} sublinks={sublinks} />;
          })}
        </div>
      ))}
    </nav>
  );
};

const FooterNavigationCol = (props) => {
  const { title, link, sublinks } = props;
  if (!title) return null;

  return (
    <div className={styles.footerColumnSection}>
      {link ? (
        <Link to={link} className={styles.linkTitle}>
          {title}
        </Link>
      ) : (
        <p className={styles.linkTitle}>{title}</p>
      )}
      <div className={styles.sublinksContainer}>
        {sublinks.map((sublink) => {
          const sublinkTitleText = sublink?.text?.text;
          const sublinkTitleUrl = sublink?.link?.url;

          return (
            <Link to={sublinkTitleUrl} key={sublinkTitleText} className={styles.sublink}>
              {sublinkTitleText}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default FooterNavigation;

export const settingsQuery = graphql`
  query FooterNavigation {
    prismicSettings {
      data {
        footer_navigation_link_1 {
          html
          text
        }
        footer_navigation_link_1_url {
          uid
          url
        }
        footer_navigation_link_1_sublinks {
          text {
            text
          }
          link {
            document {
              ... on PrismicPage {
                uid
              }
            }
            url
          }
        }
        footer_navigation_link_2 {
          html
          text
        }
        footer_navigation_link_2_url {
          uid
          url
        }
        footer_navigation_link_2_sublinks {
          text {
            text
          }
          link {
            document {
              ... on PrismicPage {
                uid
              }
            }
            url
          }
        }
        footer_navigation_link_3 {
          html
          text
        }
        footer_navigation_link_3_url {
          uid
          url
        }
        footer_navigation_link_3_sublinks {
          text {
            html
            text
          }
          link {
            document {
              ... on PrismicPage {
                uid
              }
            }
            url
          }
        }
        footer_navigation_link_4 {
          html
          text
        }
        footer_navigation_link_4_url {
          uid
          url
        }
        footer_navigation_link_4_sublinks {
          text {
            text
          }
          link {
            document {
              ... on PrismicPage {
                uid
              }
            }
            url
          }
        }
        footer_navigation_link_5 {
          html
          text
        }
        footer_navigation_link_5_url {
          uid
          url
        }
        footer_navigation_link_5_sublinks {
          text {
            text
          }
          link {
            document {
              ... on PrismicPage {
                uid
              }
            }
            url
          }
        }
        footer_navigation_link_6 {
          html
          text
        }
        footer_navigation_link_6_url {
          uid
          url
        }
        footer_navigation_link_6_sublinks {
          text {
            text
          }
          link {
            document {
              ... on PrismicPage {
                uid
              }
            }
            url
          }
        }
      }
    }
  }
`;
